import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  // eslint-disable-next-line no-underscore-dangle
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  uri: '/graphql',
});

export default client;
